module.exports = __webpack_public_path__ + "img/dropdown-arrow-down.970a29f6.svg";